import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from '@appkit4/angular-components/checkbox';
import { FieldModule } from '@appkit4/angular-components/field';
import { ModalModule } from '@appkit4/angular-components/modal';
import { PanelModule } from '@appkit4/angular-components/panel';
import { SharedModule } from '@shared/shared.module';
import { ManageEntitiesComponent } from './components/manage-entities/manage-entities.component';
import { UpsertEntityComponent } from './components/upsert-entity.component.ts/upsert-entity.component';
import { ManageEntitiesRoutingModule } from './manage-entities-routing.module';
import { GridModule } from '@shared/modules/grid/grid.module';

@NgModule({
  declarations: [ManageEntitiesComponent, UpsertEntityComponent],
  imports: [
    CommonModule,
    SharedModule,
    ManageEntitiesRoutingModule,
    ReactiveFormsModule,
    FieldModule,
    ModalModule,
    PanelModule,
    FormsModule,
    CheckboxModule,
    GridModule,
  ],
  exports: [UpsertEntityComponent],
})
export class ManageEntitiesModule {}
